import React, { useEffect, useState } from 'react';
import theme from './SensitiveInfoTooltip.module.scss';
import { Tooltip, TooltipChildren } from '@/components/Tooltip';
import { getProjectSensitiveViewerMembers } from '@/services/projects';
import { ProjectMember } from '@/types';
import { Trans } from '@lingui/react/macro';
import { UserIcon } from '@/components/Icons';
import TooltipLoading from '@/components/Tooltip/TooltipLoading';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';

interface SensitiveInfoTooltipProps {
    children: TooltipChildren;
    // itemName: string;
    // projectId?: number;
    profileId: number | null | undefined;
}

const Content: React.FC<{ members: ProjectMember[] }> = ({ members }) => {
    return (
        <div className={theme.container}>
            {/* <div className={theme.header}>
                <Trans>Sensitive document</Trans>
            </div> */}

            <div className={theme.section}>
                <Trans>
                    Documents marked as sensitive are hidden from other subcontractors and vendors and are only visible to
                    users with special permissions.
                </Trans>
            </div>

            <div className={theme.section}>
                <Trans>This document is only visible to:</Trans>

                <ul className={theme.userList}>
                    {members.map((m) => (
                        <li key={`${m.profileId}_${m.userId}`}>
                            <UserIcon userId={m.userId} sizeInPx={32} />
                            <div className={theme.name}>
                                {m.userName}
                                <small>{m.profileName}</small>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const SensitiveInfoTooltip: React.FC<SensitiveInfoTooltipProps> = ({ children, profileId }) => {
    const projectId = useSelector((state: IState) => state.global.activeProject?.id);

    const [visible, setVisible] = useState(false);
    const [members, setMembers] = useState<ProjectMember[] | null>(null);

    useEffect(() => {
        setMembers(null);
    }, [projectId, profileId]);

    useEffect(() => {
        async function load() {
            var result = await getProjectSensitiveViewerMembers(projectId!, profileId!);
            setMembers(result);
        }

        if (projectId && profileId && visible && !members) {
            load();
        }
    }, [projectId, profileId, visible, members]);

    if (!projectId || !profileId) {
        return children;
    }

    return (
        <Tooltip
            color="light"
            dynamicWidth
            title={<Trans>Sensitive document</Trans>}
            onShow={() => setVisible(true)}
            onHide={() => setVisible(false)}
            content={members ? <Content members={members} /> : <TooltipLoading />}>
            {children}
        </Tooltip>
    );
};

export default SensitiveInfoTooltip;
